import React, { useState } from "react";
import { updateFreelancerProfile } from "../../../../../services/freelancerService";

const YearsOfExperience = ({ initialYears }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [years, setYears] = useState(initialYears || 0);
    const [tempYears, setTempYears] = useState(years);
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        try {
            setLoading(true);
            await updateFreelancerProfile({ years_of_experience: tempYears });
            setYears(tempYears);
            setIsEditing(false);
        } catch (err) {
            console.error(err);
            alert("Failed to update experience.");
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setTempYears(years);
        setIsEditing(false);
    };

    return (
        <div className="experience-block">
            <h3 className="experience-title">Years of Experience</h3>
            {!isEditing ? (
                <div className="experience-value-row">
                    <p className="experience-value">{years}+ years</p>
                    <i
                        onClick={() => setIsEditing(true)}
                        className="fa-solid fa-pen experience-edit-icon"
                    ></i>
                </div>
            ) : (
                <div className="experience-edit">
                    <input
                        type="number"
                        value={tempYears}
                        onChange={(e) => setTempYears(e.target.value)}
                        className="experience-input"
                        min="0"
                    />
                    <div className="experience-btn-group">
                        <button className="experience-save-btn" onClick={handleSave}>
                            {loading ? "Saving..." : "Save"}
                        </button>
                        <button className="cancel-btn" onClick={handleCancel}>
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default YearsOfExperience;
